/*
 * MainFrameRetailGID.js:
 * This is the main UI container that includes layout, states and controls.
 * It is divided into 4 sections (divs) that are displayed based on the app's progress.
 * The transitions from one section to another is based on user interaction or API fetch state.
 */
import React, { useState } from "react";

import Div1InputGID from "./Div1InputEmail/Div1InputGID";
import Div2Searching from "./Div2UserInfo/Div2Searching";
import Div2Error from "./Div2UserInfo/Div2Error";
import Div2GIDFound from "./Div2UserInfo/Div2GIDFound";
import useSearchUser from "../hooks/useSearchUser";

import "./MainFrame.css";
import { unlockGID } from "../api/users";

const MainFrameRetailGID = ({ hasRetailGidGroup }) => {
  let usernameType = "email"; // Default username type
  console.log("MainFrameRetailGID.js: hasRetailGidGroup", hasRetailGidGroup);
  if (hasRetailGidGroup) {
    usernameType = "retailGID";
  }

  // States for MainFrame
  const [activeStep, setActiveStep] = useState(1); // Track the active step so that we can highlight in UI where we are (1= InputEmail)

  // States for Div1 (Input email)
  const [enteredEmail, setEnteredEmail] = useState(""); // Track what a user inputs in the email field

  // States for Div2 (User info and buttons)
  const [isDiv2Visible, setDiv2Visible] = useState(false); // Turns visible after Div1 Search button press
  const [div2FetchStatus, setDiv2FetchStatus] = useState(""); // '', 'searching'   , 'data'       , 'error'
  const [div2Title, setDiv2Title] = useState(""); // '', 'Searching...', 'User Found!', 'Error!'
  const [userInfo, setUserInfo] = useState({}); // {lastName, firstName, email, email2}
  const [div2Error, setDiv2Error] = useState(""); // Set only if there's an error
  const [apiProgress, setApiProgress] = useState(false);

  // Custom hooks
  const { searchUser } = useSearchUser(
    setActiveStep,
    setDiv2Visible,
    setDiv2FetchStatus,
    setDiv2Title,
    setUserInfo,
    setDiv2Error
  );

  /**
   * Reset all states to the initial values.
   */
  const resetState = () => {
    console.log("MainFrame: resetState: Resetting states...");
    setActiveStep(1); // Go back to email input
    setEnteredEmail("");

    setDiv2Visible(false);
    setDiv2FetchStatus("");
    setDiv2Title("");
    setUserInfo({});
    setDiv2Error("");
    setApiProgress(false);

  };

  /*
   ************************************************************************************************
   * Div1: Input Email
   ************************************************************************************************
   */
  const Div1SearchButtonClicked = async () => {
    // First, ensure that all other divs are hidden
    await searchUser(enteredEmail, usernameType);
    // NOTE: userInfo will be set in searchUser(), but it's not populated yet in the next line
    console.log(
      `MainFrame:Div1SearchButtonClicked: userInfo= ${JSON.stringify(userInfo)}`
    );
  };

  /*
   ************************************************************************************************
   ************************************************************************************************
   */

  const handleUnlockAccountButtonPress = async () => {
    setDiv2Title("Unlocking Account...");
    setApiProgress(true);

    await unlockGID(
      userInfo.user.activeDirectory.username,
      setDiv2FetchStatus,
      setDiv2Title,
      setUserInfo,
      setDiv2Error
    );
    setDiv2Title("Account unlocked successfully. Please allow up to 15 minutes for Active Directory to sync globally.");
    setDiv2Error("Account unlocked successfully. Please allow up to 15 minutes for Active Directory to sync globally.");
    userInfo.user.status = "ACTIVE";
    userInfo.user.activeDirectory.locked = false;
    console.log(
      `MainFrame:handleUnlockAccountButtonPress: username= ${JSON.stringify(
        userInfo.user.activeDirectory.username
      )}`
    );

    setApiProgress(false);
  };

  // If user wasn't found or error occurred, 'Start over'
  const Div2StartOverClicked = () => {
    resetState();
  };

  
  if (hasRetailGidGroup === false) {
    return (
      <div className="main-wrapper">
        <h1 className="text-color-red">
          You do not have access to this application.
        </h1>
        <p className="text-color-red">
          Please contact your manager or the EIAM Operations team for
          assistance.
        </p>
      </div>
    );
  }

  return (
    <div className="main-wrapper">
      <Div1InputGID
        enteredEmail={enteredEmail}
        setEnteredEmail={setEnteredEmail}
        Div1SearchButtonClicked={Div1SearchButtonClicked}
        setUserInfo={setUserInfo}
        setDiv2Visible={setDiv2Visible}
        apiProgress={apiProgress}
        setApiProgress={setApiProgress}
        activeStep={activeStep}
      />

      {isDiv2Visible && div2FetchStatus === "searching" && (
        <Div2Searching div2Title={div2Title} activeStep={activeStep} />
      )}

      {console.log(userInfo)}

      {isDiv2Visible && div2FetchStatus === "data" && (
        <Div2GIDFound
          div2Title={div2Title}
          userInfo={userInfo.user}
          activeStep={activeStep}
          apiProgress={apiProgress}
          handleUnlockAccountButtonPress={handleUnlockAccountButtonPress}
        />
      )}

      {isDiv2Visible && div2FetchStatus === "error" && (
        <Div2Error
          div2Title={div2Title}
          errorMsg={div2Error}
          Div2StartOverClicked={Div2StartOverClicked}
          activeStep={activeStep}
        />
      )}
    </div>
  );
};

export default MainFrameRetailGID;
